import React from "react";
import "react-tabs/style/react-tabs.css";
import { Button } from "react-bootstrap";
import { Badge } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { withRouter } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { CardBody } from "reactstrap";
import EditIcon from '@material-ui/icons/Create';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import SimpleReactValidator from 'simple-react-validator';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dateFormat from 'dateformat';
import { connect } from "react-redux";
import 'moment/locale/fr.js' // or 'rc-datepicker/node_modules/moment/locale/fr.js' if you don't have it in your node_modules folder
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import moment from "moment";
import { toast } from 'react-toastify';

class ChildComplaint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: [""],
      adminPass: "", statusEdit: [], statusUpdate: false, remarks: "", status: "",userparentcomp:"",
      fromDate: "", toDate: "", fromDate1: "", toDate1: "", pricePerKL: "", selectDate: "", selectDate1: "", contractPriceToDate: "", contractPriceFromDate: "", userparentcomp: ""
      ,childcategory: "",parentdataid: "",
	  parentid: "",
	  childcategorystatus: "",
	  childId: "",
	  activeParentList: [],
	  childData: [],
	  
    };
    this.submitHandler = this.submitHandler.bind(this);
	this.validator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
    this.pdValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
  }

  submitHandler = () => {
    this.props.history.path("/user/user-create")
  }


  nextPath(path) {
    this.props.history.push({ pathname: path });
  }

  componentDidMount() {
    const url = process.env.REACT_APP_NODE_ENV + "/api/compliant/activeparentlist";
    fetch(url,{
      method:'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => {
        return response.json();
      }
    ).then(data => {
        console.log(data.data)
       this.setState({ activeParentList: data.data })
    })
  

  const url1 = process.env.REACT_APP_NODE_ENV + "/api/compliant/childlist";
    fetch(url1,{
      method:'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => {
        return response.json();
      }
    ).then(data => {
       // console.log(data.data)
       this.setState({ childData: data.data })
    })
  }

// editStatuschild = value => {
    // const doesToggle = this.state.editStatuss;
    // this.setState({ parentcategorystatus: value[3], userparentcomp: value[1], parenteditid:value[0], editStatuss: !doesToggle });

// }

  editStatusHandler = value => {
	  console.log(value)
    const doesToggle = this.state.editStatus;
    this.setState({ childId: value[0], parentdataid: value[1], childcategory: value[2],childcategorystatus: value[4], editStatus: !doesToggle });
  };
  editStatuschild = () => {
    const doesToggle = this.state.editStatuss;
    this.setState({ editStatuss: !doesToggle });

  }

  save = () => {
    
    if (this.pdValidator.allValid()) {
      this.setState({ editStatus: false })
      let postOrderData = "";
      if (this.state.userparentcomp) {

        postOrderData = { 
            "parent_category" : this.state.userparentcomp,
            "status":"1"
           }
        console.log(postOrderData)
        fetch(process.env.REACT_APP_NODE_ENV + '/api/compliant/createparent', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
          },
          body: JSON.stringify(postOrderData)
        }).then((res) => res.json())
          .then((data) => {
            console.log(data)
            this.componentDidMount()
            toast.success("parent  Category Inserted Successfully", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000
              });
          })
          .catch((err) => console.log(err))
      }
      else {
        this.componentDidMount();
      }
    }
    else {
      this.pdValidator.showMessages();
      this.forceUpdate();
    }
  }
  savechild = () => {
   // console.log(this.state.childcategory , this.state.parentdataid)


   let postOrderData = "";
  if (this.validator.allValid()) {

     postOrderData = { 
        "parent_id": this.state.parentdataid,
        "child_category" : this.state.childcategory,
        "status": this.state.childcategorystatus === "" ? 1:this.state.childcategorystatus
        }
     console.log(postOrderData)
     fetch(process.env.REACT_APP_NODE_ENV + '/api/compliant/createchild', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json',
         'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
       },
       body: JSON.stringify(postOrderData)
     }).then((res) => res.json())
       .then((data) => {
         this.componentDidMount()
         this.setState({ editStatuss: false, statusUpdate: false });
         toast.success("Child Category created Successfully", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000
          });
       })
       .catch((err) => console.log(err))
   }
   else {
	   this.validator.showMessages();
     this.componentDidMount();
   }

  }
  
  editChild = () => {
	 this.setState({ editStatus: false })
   let postOrderData = "";
  if (this.validator.allValid()) {

     postOrderData = { 
        "child_id": this.state.childId,
        "parent_id": this.state.parentdataid,
        "child_category" : this.state.childcategory,
        "status": this.state.childcategorystatus
        }
     console.log(postOrderData)
     fetch(process.env.REACT_APP_NODE_ENV + '/api/compliant/editchild', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json',
         'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
       },
       body: JSON.stringify(postOrderData)
     }).then((res) => res.json())
       .then((data) => {
         this.componentDidMount()
         this.setState({ editStatuss: false, statusUpdate: false });
         toast.success("Child category updated successfully", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000
          });
       })
       .catch((err) => console.log(err))
   }
   else {
	   this.validator.showMessages();
     this.componentDidMount();
   }

  }
  
  onchangeuser =(e) => {
  // this.setState({ userparentcomp: e.target.value});
    // alert (e.target.value)
  }
  handleformdata = (e) => {
    
   this.setState({ childcategory : e.target.value})

  }
  handleEditFormFields = (event) => { 
    this.setState({ parentdataid : event.target.value })
  }
  handleSelectStatus =(e) => {
    this.setState({ childcategorystatus: e.target.value});
  }

  popUpCancel = () => {
    this.setState({ editStatus: false, statusUpdate: false });
  }
  popUpCancel1 = () => {
    this.setState({ editStatuss: false, statusUpdate: false });

  }

  handleUserFormFields = event => {
    this.pdValidator.showMessageFor(event.target.name)
    switch (event.target.id) {
        case "ufirstName":
            this.setState({ userFirstName: event.target.value });
            break;
        case "ulastName":
            this.setState({ userLastName: event.target.value });
            break;
      case "pdToDate":
        this.setState({ toDate: event.target.value, statusUpdate: true });
        break;
      case "pdPricePerKL":
        this.setState({ pricePerKL: event.target.value, statusUpdate: true });
        break;
      default:
        break;
    }
  };

  handleChange2 = date => {
    this.setState({ contractPriceFromDate: date, statusUpdate: true });
  };

  handleChange3 = date => {
    this.setState({ contractPriceToDate: date, statusUpdate: true });
  };

  render() {
    let parent_data = this.state.activeParentList.map(data => (
        <option key={data.id} value={data.id}>{data.parent_category}</option>
      ))

    let statusEdit = (
      <div className="kt-wizard-v1__form">
        <div className="row">
			<div className="col-lg-8">
				<label><b>Parent Category </b></label>
				<select name="parent Complaint" id="parentid"  name="parentid" className="form-control" value={this.state.parentdataid} onChange={this.handleEditFormFields} >
					<option value="">Select Parent Category</option>
					{parent_data}
				</select>
				{
					this.validator.message('parent Category', this.state.parentdataid, 'required')
				}
			</div> 
			<div className="col-lg-8">
			  <label></label>
			  <label><b>child Category </b></label>
				<div className="form-group">
					  <input type=" text" className="form-control" pattern="[A-Za-z]{3}" required name="child category" id="ulastName" placeholder="Child Category" value={this.state.childcategory} onChange={this.handleformdata} />
				</div>
				{
					this.validator.message('Child Category', this.state.childcategory, 'required')
				}
				</div>
			</div>
			<div className="col-lg-8">
			  <label> <b>Status</b> </label><select id="childcategorystatus"  name="childcategorystatus" className="form-control" value={this.state.childcategorystatus} onChange={this.handleSelectStatus} >
				<option value="1">Active</option>
				<option value="2">InActive</option>
			  </select>     
			</div>
      </div>)


let AddChildCategory = (
    <div className="kt-wizard-v1__form">
		<div className="row">
			  <div className="col-lg-8">
				 <label><b>Parent Category </b></label>
				<select name="parent Complaint" id="parentid"  name="parentid" className="form-control" onChange={this.handleEditFormFields} >
					<option value="">Select Parent Category</option>
					{parent_data}
				</select>
				{
					this.validator.message('Parent Category', this.state.parentdataid, 'required')
				}
			  </div> 
			  <br />
				<div className="col-lg-8">
				  <label></label>
				  <label><b>child Category </b></label>
					<div className="form-group">
						  <input type=" text" className="form-control" pattern="[A-Za-z]{3}" required name="child category" id="ulastName" placeholder="Child Category" onChange={this.handleformdata} />
					</div>
					{
						this.validator.message('Child Category', this.state.childcategory, 'required')
					}
					</div>
				</div>
				<div className="col-lg-8">
				  <label> <b>Status</b> </label><select id="childcategorystatus"  name="childcategorystatus" className="form-control" onChange={this.handleSelectStatus} >
					<option value="1">Active</option>
					<option value="2">InActive</option>
				  </select>    
				</div>
        <div>
	</div>
	
	
      <br/><br />
     
    </div>)



    let dataArray = [];
    this.state.childData.map((data) => {
      let variant = "";
        let statusdata = "";
        if(data.status === "2") { variant = "danger";  statusdata = "InActive" }
          else { variant = "success" ; statusdata = "Active" }
      let mdData = {
        key: data.id,
        id: data.id, parent_id: data.parent_id, ChildCategory: data.child_category, Status: <Badge pill variant={variant}>{statusdata}</Badge>, Statusvalue: data.status,createdAt: data.createdAt,data };
      dataArray.push(mdData);
    });


    const columns = [
		{
        name: "id",
        label: "Id",
        options: {
          filter: true,
          sort: true,
        }
      },
	   {
        name: "parent_id",
        label: "parent_id",
        options: {
          filter: true,
          sort: true,
		  display: false,
        }
      },
      {
        name: "ChildCategory",
        label: "child Category",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "Status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
        }
      },
	   {
        name: "Statusvalue",
        label: "Statusvalue",
        options: {
          filter: true,
          sort: true,
		  display: false,
        }
      },
      {
        name: "createdAt",
        label: "Created At",
        options: {
          filter: true,
          sort: true,
        }
      },	 
       {
         name: "actions",
         label: "Actions",
         options: {
           filter: false,
           sort: false,
           customBodyRender: (value, tableMeta, updateValue) => {
			   // console.log(tableMeta)
             return (
               <><Tooltip title="Edit Status"><IconButton>
               <EditIcon onClick={() => this.editStatusHandler(tableMeta.rowData)} /></IconButton></Tooltip> </>
            );
          }
         }
       }
    ];


    const options = {
      filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false
    };

    let PriceMasterTable = (<Card>
      <Card.Body>
        <div>
           <Button className="float-right"
            variant="outline-success"
            style={{ marginTop: "10px", width: "150px", marginRight: "25px" }}
            onClick={() => this.editStatuschild()}>
            Add Child
 </Button></div>
        <MUIDataTable
          data={dataArray}
          columns={columns}
          options={options} />
      </Card.Body>
    </Card>);

    let editStatuss = null;
    if (this.state.editStatus) {
      editStatuss = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
              <ModalHeader>Edit Child Category</ModalHeader>
              <ModalBody>
                {statusEdit}
              </ModalBody>
              <ModalFooter>
                <Button variant="outline-primary" onClick={() => this.editChild()}>
                  Save
            </Button>&nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={() => this.popUpCancel()}> Cancel </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }
    
    let editStatusss = null;
    if (this.state.editStatuss) {
      editStatusss = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
              <ModalHeader>Add Child Category</ModalHeader>
              <ModalBody>
                {AddChildCategory}
              </ModalBody>
              <ModalFooter>
                <Button variant="outline-primary" onClick={() => this.savechild()}>
                  Save
            </Button>&nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={() => this.popUpCancel1()}> Cancel </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }
    

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item active>Child Compliant</Breadcrumb.Item>
        </Breadcrumb>
        {editStatuss} 
        {editStatusss}

        <div>
          {PriceMasterTable}
        </div>
      </>
    );
  }
}

export default ChildComplaint;
